import React from 'react'
import { Box, Typography } from "@mui/material"


export default function userNameColumn() {

	return {
		name: 'uid_translation',
		label: 'User',
		options: {
			filterType: "textField",
			headerAlign: "left",
			customBodyRowRenderLite: value => <Box sx={{ display: "flex" }}>
				<Typography variant="subtitle1">
					{value}
				</Typography>
			</Box>
		},
	}
}